import { Layer } from '@mono/types/src/platmap';
import { delimiter } from './constants';

export const getLayerIndex = (layer: Layer) => {
    return ['plat', layer.state.type, layer.id].join(delimiter);
};
